import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class HealthGroupService {

  constructor(private authService: AuthService,
              private http: HttpClientWrapperService) {
  }

  getOffers() {
    return this.http.get('health-group/statistics/offers');
  }

  getRequestInfo(requestID: number) {
    return this.http.get(`health-group/statistics/details/${requestID}`, this.authService.decode().auth);
  }
}
